<shared-modal [modalTitle]="'Change password'">
  <ng-container modalBody>
    <auth-set-password-form (passwordChange)="close()" />
  </ng-container>
</shared-modal>
